import { bool, func, number, oneOfType, shape, string } from 'prop-types';
import React from 'react';
import { actions as applicationActions } from '../../features/Application';
import FormBox from '../../components/Form/FormBox';
import PageTitle from '../../components/PageTitle';
import AddMember from './AddMember';
import CheckBox from '../../components/CheckBoxes/CheckBox';
import FormHOC from '../../features/HOC/FormHOC';
import TextField from '../../components/TextField';
import { getters as formGetters } from '../../features/Form';

function Member({
  addMember,
  approvalStatus1,
  approvalStatus2,
  index,
  removeMember,
  showMember2,
  showDetails2,
  showApartment2,
  submitForm,
  hasOtherApartment,
  currentApplicant: { apartments },
  ...rest
}) {
  function filterApartments() {
    return Object.values(apartments).filter((apartment) => Boolean(apartment));
  }

  function getAddress() {
    const filteredApartments = filterApartments();
    if (!filteredApartments.length) {
      return '';
    } else if (filteredApartments.length > 1) {
      return filteredApartments[index - 1].address;
    }
    return filteredApartments[0].address;
  }

  function getForm() {
    const form = [
      {
        title: 'Namn',
        id: 'name',
        placeholder: 'Namn',
        description: 'Ange det namn som ska stå på kontraktet',
      },
      {
        title: 'E-post',
        id: 'email',
        type: 'email',
        placeholder: 'E-postadress',
        description: 'Ange din e-postadress',
        validation: 'email',
      },
      {
        title: 'Telefonnummer',
        id: 'phone',
        type: 'number',
        placeholder: 'Telefonnummer',
        description: 'Ange dit telefonnummer',
      },
      {
        title: 'Personnummer',
        id: 'ssn',
        placeholder: 'Personnummer',
        description: 'Ange ditt som personnummer',
        validation: 'ssn',
      },
      {
        title: 'Adress',
        id: 'registeredAddress',
        placeholder: 'Adress',
        description: 'Ange din folkbokföringsadress',
      },
      {
        title: 'Postnummer',
        id: 'registeredPostalCode',
        type: 'number',
        placeholder: 'Postnummer',
        description: 'Ange postnumret till din folkbokföringsadress',
        validation: 'zip',
      },
      {
        title: 'Ort',
        id: 'registeredCity',
        placeholder: 'Ort',
        description: 'Ange orten till din folkbokföringsadress',
      },
      {
        title: 'Annat fastighetsinnehav',
        id: 'hasOtherApartment',
        description:
          'Denna person har ett annat fastighetsinnehav, t.ex. en bostadsrätt, hyresrätt, fritidshus eller övrig fastighet',
        component: CheckBox,
        type: 'checkbox',
      },
      {
        title: 'Står på kontrakt',
        id: 'onCurrentContract',
        description: `Denna person står på hyreskontraktet för ${getAddress()}`,
        component: CheckBox,
        type: 'checkbox',
      },
    ];
    if (hasOtherApartment) {
      form.splice(form.length - 1, 0, {
        id: 'otherApartmentInfo',
        description: 'Typ av fastighetsinnehav',
        component: TextField,
      });
    }
    return form;
  }

  const status = index === 1 ? approvalStatus1 : approvalStatus2;

  const showMember = !showDetails2;

  return (
    <div>
      {showMember && (
        <AddMember
          addMember={addMember}
          removeMember={removeMember}
          isAdd={!showMember2 && index !== '2'}
        />
      )}
      <PageTitle>Person #{index}</PageTitle>
      <FormBox
        form={getForm()}
        handleClick={(e) => submitForm(e, index)}
        status={status}
        {...rest}>
        <p>
          <strong>Observera att ansökan måste signeras med BankID.</strong>{' '}
          Kontakta din bank för mer information om du saknar BankID.
        </p>
      </FormBox>
    </div>
  );
}

Member.propTypes = {
  addMember: func.isRequired,
  approvalStatus1: shape({
    type: string,
  }).isRequired,
  approvalStatus2: shape({
    type: string,
  }),
  index: oneOfType([string, number]).isRequired,
  removeMember: func.isRequired,
  showMember2: bool.isRequired,
  submitForm: func.isRequired,
  hasOtherApartment: bool,
};

Member.defaultProps = {
  approvalStatus2: {
    type: '',
  },
  hasOtherApartment: false,
};

export default FormHOC(Member, {
  actions: {
    addMember: applicationActions.addMember,
    removeMember: applicationActions.removeMember2,
  },
  state: (state) => ({
    showMember2: state.application.showMember2,
    showDetails2: state.application.showDetails2,
    showApartment2: state.application.showApartment2,
    hasOtherApartment: formGetters.getFieldValue(
      state.form,
      'hasOtherApartment'
    ),
  }),
  form: 'members',
  field: 'member',
});



// WEBPACK FOOTER //
// ./src/views/Member/index.js